import { Clock, WarningCircle, WhatsappLogo, ChatCircleDots } from "@phosphor-icons/react";

// CTA destinations — Tunca Özdemir (Pumble user id from edugen.users#524).
const WHATSAPP_NUMBER = "905323048683";
const PUMBLE_DM_URL = "https://app.pumble.com/workspace/67f5356953833205f81b99b1/686377f41769c00fbb5e7135";
const PUMBLE_INVITE_URL = "https://invite.pumble.com/x77qqcjqh1kp85dqhk";

export function TuncaContactButtons({ whatsappText }: { whatsappText: string }) {
  return (
    <>
      <div className="flex flex-wrap gap-2 mt-3">
        <a
          href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappText)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 bg-[#25D366] text-black font-semibold text-xs px-3 py-1.5 rounded-lg hover:opacity-90"
        >
          <WhatsappLogo size={14} weight="fill" /> WhatsApp ile Yaz
        </a>
        <a
          href={PUMBLE_DM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 bg-[#5B47E5] text-white font-semibold text-xs px-3 py-1.5 rounded-lg hover:opacity-90"
        >
          <ChatCircleDots size={14} weight="fill" /> Pumble'da Yaz
        </a>
      </div>
      <div className="text-[10px] text-white/30 mt-2">
        Pumble hesabın yoksa{" "}
        <a
          href={PUMBLE_INVITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-white/50"
        >
          davet linki
        </a>
        .
      </div>
    </>
  );
}

function formatRemaining(ms: number): { label: string; critical: boolean } {
  if (ms <= 0) return { label: "expired", critical: true };
  const totalMinutes = Math.floor(ms / 60_000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes - days * 60 * 24) / 60);
  const minutes = totalMinutes - days * 60 * 24 - hours * 60;

  if (days >= 1) return { label: `${days} gün ${hours} saat`, critical: false };
  if (hours >= 1) return { label: `${hours} saat ${minutes} dakika`, critical: false };
  return { label: `${minutes} dakika`, critical: true };
}

export default function DemoCountdownCard({
  cohortName,
  demoEndDate,
}: {
  cohortName: string | undefined;
  demoEndDate: string | null | undefined;
}) {
  const isDemo = !!cohortName && /demo/i.test(cohortName);
  if (!isDemo || !demoEndDate) return null;

  const remainingMs = new Date(demoEndDate).getTime() - Date.now();
  const { label } = formatRemaining(remainingMs);
  const expired = remainingMs <= 0;

  const borderClass = expired ? "border-red-500/40" : "border-myAmber/40";
  const bgClass = expired ? "bg-red-500/10" : "bg-myAmber/10";
  const accentText = expired ? "text-red-400" : "text-myAmber";
  const Icon = expired ? WarningCircle : Clock;

  return (
    <div className={`rounded-2xl border ${borderClass} ${bgClass} p-4 mb-6`}>
      <div className="flex items-start gap-3">
        <Icon size={24} weight="fill" className={accentText} />
        <div className="flex-1">
          <div className={`text-base font-bold ${accentText} mb-0.5`}>
            {expired ? "Demo süren bitti" : `Demo'n ${label} sonra bitiyor`}
          </div>
          <div className="text-white/60 text-sm">
            {expired
              ? "Devam etmek için Tunca Hoca ile iletişime geç."
              : "Tüm dersleri açmak için Tunca Hoca ile iletişime geç."}
          </div>
          <TuncaContactButtons whatsappText="Merhaba Tunca Hoca, demo sürem hakkında konuşmak istiyorum." />
        </div>
      </div>
    </div>
  );
}

export { formatRemaining };
